import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Matrimony from "@/pages/Matrimony";
import Jobs from "@/pages/Jobs";
import Marketplace from "@/pages/Marketplace";
import Training from "@/pages/Training";
import Games from "@/pages/Games";
import DoctorChat from "@/pages/DoctorChat";
import Storefront from "@/pages/Storefront";
import Orders from "@/pages/Orders";
import Admin from "@/pages/Admin";
import Support from "@/pages/Support";
import Doctors from "@/pages/Doctors";
import Lawyers from "@/pages/Lawyers";
import Events from "@/pages/Events";
import MyPrints from "@/pages/MyPrints";
import MyCoupons from "@/pages/MyCoupons";
import EventVerify from "@/pages/EventVerify";
import PublicEvent from "@/pages/PublicEvent";
import EventRoster from "@/pages/EventRoster";
import { PrintOrder, PrintApplication, PrintCertificate, PrintDoctorConsult, PrintLegalConsult, PrintEventTicket } from "@/pages/PrintPages";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import CertificateVerify from "@/pages/CertificateVerify";
import { Toaster } from "sonner";
import InstallPrompt from "@/components/InstallPrompt";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/discover" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/matrimony" element={<Matrimony />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/marketplace" element={<Marketplace />} />
                <Route path="/training" element={<Training />} />
                <Route path="/games" element={<Games />} />
                <Route path="/doctor" element={<DoctorChat />} />
                <Route path="/store/:userId" element={<Storefront />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/support" element={<Support />} />
                <Route path="/doctors" element={<Doctors />} />
                <Route path="/lawyers" element={<Lawyers />} />
                <Route path="/events" element={<Events />} />
                <Route path="/my-prints" element={<MyPrints />} />
                <Route path="/my-coupons" element={<MyCoupons />} />
                <Route path="/prints/order/:id" element={<PrintOrder />} />
                <Route path="/prints/application/:id" element={<PrintApplication />} />
                <Route path="/prints/certificate/:id" element={<PrintCertificate />} />
                <Route path="/prints/consult/:id" element={<PrintDoctorConsult />} />
                <Route path="/prints/legal/:id" element={<PrintLegalConsult />} />
                <Route path="/events/ticket/:id/print" element={<PrintEventTicket />} />
                <Route path="/events/verify/:id" element={<EventVerify />} />
                <Route path="/e/:id" element={<PublicEvent />} />
                <Route path="/events/:id/roster" element={<EventRoster />} />
                <Route path="/legal/thread/:id/print" element={<PrintLegalConsult />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/certificates/verify/:token" element={<CertificateVerify />} />
              </Routes>
            </Layout>
            <Toaster position="top-right" richColors />
            <InstallPrompt />
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
